export const NR_SESSION_START = 'SesssionStart'
export const NR_LOGIN_EMAIL = 'LoginEmail'
export const NR_LOGIN_STEP = 'LoginStep';
export const NR_LOGIN_PASSWORD = 'LoginPassword'
export const NR_MFA_OTP_REGISTRATION = 'MfaOtpRegistration'
export const NR_MFA_MOBILE_REGISTRATION = 'MfaMobileRegistration'
export const NR_MFA_OTP_AUTHENTICATION = 'MfaOtpAuthentication'
export const NR_MFA_MOBILE_AUTHENTICATION = 'MfaMobileAuthentication'
export const NR_LOGIN_PASSKEY = 'LoginPasskey'
export const NR_REDIRECT_TO_PRODUCT = 'RedirectToProduct'
export const NR_ABANDON_LOGIN_PROCESS = 'AbandonLoginProcess'
export const NR_PASSKEY_REGISTRATION_STEP = 'PasskeyRegistrationStep'
export const NR_PASSKEY_REGISTRATION_START = 'PasskeyRegistrationStart'
export const NR_PASSKEY_REGISTRATION_COMPLETE = 'PasskeyRegistrationComplete'
export const NR_ABANDON_PASSKEY_REGISTRATION = 'AbandonPasskeyRegistration'

export const EMAIL_DOMAIN_SITEMINDER = '@siteminder.com'

export enum NR_STEPS {
  LOGIN_EMAIL = 'LoginEmailStep',
  LOGIN_PASSWORD = 'LoginPasswordStep',
  MFA_OTP_REGISTRATION = 'MfaOtpRegistrationStep',
  MFA_MOBILE_REGISTRATION = 'MfaMobileRegistrationStep',
  MFA_OTP_AUTHENTICATION = 'MfaOtpAuthenticationStep',
  MFA_MOBILE_AUTHENTICATION = 'MfaMobileAuthenticationStep',
  LOGIN_PASSKEY = 'LoginPasskeyStep',
  REDIRECT_TO_PRODUCT = 'RedirectToProductStep',
}

export enum NR_PASSKEY_REGISTRATION_STEPS {
  PASSKEY_REGISTRATION_START = 'PasskeyRegistrationStartStep',
  PASSKEY_REGISTRATION_COMPLETE = 'PasskeyRegistrationCompletedStep'
}
